module.exports = __webpack_public_path__ + "img/EQUAL.5fe468c1.svg";